// Import model
import { StartEstimateEditItemRequest } from '../models/StartEstimateEditItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartEstimateEditItemRequest - handles JSON serialization and deserialization with type validation
 */
export class StartEstimateEditItemRequestSerializer {
  /**
   * Deserializes a JSON string into a StartEstimateEditItemRequest instance
   */
  static deserialize(json: string): StartEstimateEditItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartEstimateEditItemRequest instance
   */
  static fromObject(obj: any): StartEstimateEditItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartEstimateEditItemRequest');
    }


    const instance: StartEstimateEditItemRequest = {
      source: obj['source'] as string | undefined,
      itemId: obj['itemId'] as string | undefined,
      margin: obj['margin'] as number | undefined,
      wasteFactor: obj['wasteFactor'] as number | undefined,
      quantity: obj['quantity'] as number | undefined,
      uom: obj['uom'] as string | undefined,
      unitCost: obj['unitCost'] as number | undefined,
      uomAbbreviation: obj['uomAbbreviation'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartEstimateEditItemRequest instances
   */
  static deserializeArray(json: string): StartEstimateEditItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartEstimateEditItemRequest instance to a JSON string
   */
  static serialize(instance: StartEstimateEditItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartEstimateEditItemRequest instance to a plain object
   */
  static toObject(instance: StartEstimateEditItemRequest): any {
    return {
      'source': instance.source,
      'itemId': instance.itemId,
      'margin': instance.margin,
      'wasteFactor': instance.wasteFactor,
      'quantity': instance.quantity,
      'uom': instance.uom,
      'unitCost': instance.unitCost,
      'uomAbbreviation': instance.uomAbbreviation,
    };
  }

  /**
   * Serializes an array of StartEstimateEditItemRequest instances to a JSON string
   */
  static serializeArray(instances: StartEstimateEditItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
